export enum RouterNames {
  AUTH_ERROR = 'Authorisation error',
  HOME = 'home',
  LOGIN = 'login',
  USERS = 'users',
  TASKS = 'tasks',
}
